document.addEventListener('DOMContentLoaded', () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target); 
            }
        });
    }, {
        threshold: 0.15 
    });

    const blocks = document.querySelectorAll('.has-scroll-animation');
    blocks.forEach((block) => observer.observe(block));
});
